module.exports = __webpack_public_path__ + "static/media/BW201910_04.b3cfa531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/BW201910_04.jpg
// module id = 373
// module chunks = 0